export enum LocalStorageType {
       UserLanguage = 'lang',
       ViewMode = 'viewMode'
   }